<div class="contenedor-general">
  <div *ngIf="data.producto">
    <mat-icon (click)="close()">cancel</mat-icon>
    <h2>{{ data.producto.nombre }}</h2>
    <div class="producto-caracteristicas-contenedor">
      @if (loading) {
        <cgw-spinner *ngIf="loading"></cgw-spinner>
      } @else {
        <div
          class="contenedor-especificaciones"
          *ngIf="specifications && specifications.length > 0">
          <div
            *ngFor="let cat of specifications; let i = index"
            class="contenedor-caracteristicas">
            <h3>{{ cat.nombre | uppercase }}</h3>
            <div
              *ngFor="let caract of cat.$caracteristicas; let index = index"
              [ngClass]="{ odd: index % 2 == 0, even: index % 2 == 1 }"
              class="caracteristicas-contenido">
              <span>{{ caract.etiqueta | titlecase }}</span>
              <span>
                {{ caract.valor | productCharacteristicType: caract.tipo : caract.unidades }}
              </span>
            </div>
          </div>
        </div>
        <div
          class="contenedor-especificaciones no-especificaciones"
          *ngIf="specifications && specifications.length == 0">
          <p>El producto seleccionado no contiene especificaciones</p>
        </div>
      }
    </div>
  </div>
  <div
    *ngIf="!data.producto && !data.alertaPlaca"
    class="reset">
    <h3>¿Estás seguro/a?</h3>
    <p>Esto borrará de tu carrito los productos seleccionados</p>
    <button
      mat-raised-button
      color="primary"
      class="clean"
      [mat-dialog-close]="true">
      Limpiar selección
    </button>
    <button
      mat-stroked-button
      color="primary"
      (click)="close()">
      Cancelar
    </button>
  </div>
  <div
    *ngIf="data.alertaPlaca"
    class="reset">
    <h3>La placa de video seleccionada no puede enviarse instalada</h3>
    <p>
      Para preservar la integridad física, y evitar roturas durante el envio, las placas que cuentan
      con 3 Cooler Fan (o más) serán testeadas con el resto de los componentes pero se enviarán en
      su caja original para ser instalada por el cliente.
    </p>
    <button
      mat-raised-button
      color="primary"
      class="clean"
      (click)="close()">
      Aceptar
    </button>
  </div>
</div>
